/* eslint no-console: ["error", { allow: ["warn", "error", "log"] }] */

import { Observable } from 'rxjs';
import { combineEpics } from 'redux-observable';

import { CHAT_INFO_REQUEST, success, failure } from './action';

const events = (action$, state$, { AjaxRequest }) =>
  action$
    .ofType(CHAT_INFO_REQUEST)
    .map(({ payload: { customId } }) => customId)
    .mergeMap((id) =>
      AjaxRequest.open(
        'get',
        `/services/person/fromcustomid?livechatcustomerid=${id}`,
      )('tudo')
        .flatMap(({ response }) => Observable.of(success(response.resource)))
        .catch((err) => Observable.of(failure(err))),
    );

export default combineEpics(events);
